var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contact-verification-step" },
    [
      _c("div", { staticClass: "fm-info-banner mb-4" }, [
        _c(
          "svg",
          {
            attrs: {
              fill: "currentColor",
              viewBox: "0 0 16 16",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "We'll send a verification code to your email and mobile to confirm your contact details."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "otp-grid" }, [
        _c(
          "div",
          { staticClass: "otp-grid__item" },
          [
            _c("p", { staticClass: "fm-section-label" }, [
              _c(
                "svg",
                {
                  staticStyle: {
                    width: "12px",
                    height: "12px",
                    "margin-right": "4px",
                  },
                  attrs: {
                    fill: "currentColor",
                    viewBox: "0 0 16 16",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z",
                    },
                  }),
                ]
              ),
              _vm._v("\n        Email\n      "),
            ]),
            _vm._v(" "),
            _c("EmailVerification", {
              ref: "emailVerification",
              attrs: { "error-container": _vm.errorContainerName },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "otp-grid__divider" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "otp-grid__item" },
          [
            _c("p", { staticClass: "fm-section-label" }, [
              _c(
                "svg",
                {
                  staticStyle: {
                    width: "12px",
                    height: "12px",
                    "margin-right": "4px",
                  },
                  attrs: {
                    fill: "currentColor",
                    viewBox: "0 0 16 16",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: { d: "M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" },
                  }),
                ]
              ),
              _vm._v("\n        Mobile\n      "),
            ]),
            _vm._v(" "),
            _c("PhoneVerification", {
              ref: "phoneVerification",
              attrs: { "error-container": _vm.errorContainerName },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.canGoNext
        ? _vm._t("controls", null, null, { prev: _vm.onPrev, next: _vm.onNext })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }